import { Component, OnInit, Input } from '@angular/core';
import { LookupsService } from 'src/app/shared/services/lookups.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-select-consultant',
  templateUrl: './select-consultant.component.html',
  styleUrls: ['./select-consultant.component.scss']
})
export class SelectConsultantComponent implements OnInit {

  @Input() caseId: number;
  @Input() showTravelling: boolean = false;

  externalConsultants: any[] = [];
  title = 'Select Consultant';
  loading = true;


  constructor(
    private lookupsService: LookupsService, 
    public activeModal: NgbActiveModal) 
  {
  }

  ngOnInit() {
    if (this.showTravelling) {
      this.title = 'Travelling Consultants in next 7 days'
    }

    this.loadData()
  }

  loadData() {

    this.loading = true;

    if (this.showTravelling) {
      this.lookupsService.getTravellingConsultantsForCase(this.caseId).subscribe((result : any) => {
        this.externalConsultants = result;
        this.loading = false;
      });
    } else {
      this.lookupsService.getExternalConsultantsForCase(this.caseId).subscribe((result : any)  => {
        this.externalConsultants = result;
        this.loading = false;
      });
    }
  }

  close(id: number, name: string) {
    this.activeModal.close({ externalConsultantId: id, externalConsultantName: name });
  }


}
